// EGKCRM-514 PR-2：JWT 解碼共用 util
// 解開 localStorage 的 Jwt token 的 payload segment，回傳 parsed object。
// 無 token / decode 失敗 → 回 null。
export function parseJwt (token) {
  if (!token || typeof token !== 'string') return null
  try {
    const base64Url = token.split('.')[1]
    if (!base64Url) return null
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(jsonPayload)
  } catch (e) {
    console.error('parseJwt failed', e)
    return null
  }
}

// 從當前 localStorage 的 Jwt 取出 userId（nameidentifier claim）
export function getCurrentUserId () {
  const jwt = parseJwt(window.localStorage.getItem('Jwt'))
  if (!jwt) return null
  return jwt['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] || null
}

// 從當前 localStorage 的 Jwt 取出 roles（claim 可能是 string 或 array）
export function getCurrentRoles () {
  const jwt = parseJwt(window.localStorage.getItem('Jwt'))
  if (!jwt) return []
  const claim = jwt['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
  if (!claim) return []
  return Array.isArray(claim) ? claim : [claim]
}
